import PropTypes from "prop-types";

/**
 * Reusable empty state component for displaying when no data is available
 * Supports optional icon and call-to-action button
 *
 * @component
 * @param {Object} props
 * @param {string} props.message - Empty state message
 * @param {string} [props.icon] - Icon class name
 * @param {React.Node} [props.ctaButton] - Call-to-action button element
 * @param {string} [props.className=""] - Additional CSS classes
 */
const EmptyState = ({ message, icon, ctaButton, className = "" }) => {
  return (
    <div className={`text-center py-5 ${className}`}>
      {icon && (
        <div className="mb-3">
          <i className={icon} style={{ fontSize: "3rem", color: "#999" }}></i>
        </div>
      )}
      <h4>{message}</h4>
      {ctaButton && <div className="mt-3">{ctaButton}</div>}
    </div>
  );
};

EmptyState.propTypes = {
  message: PropTypes.string.isRequired,
  icon: PropTypes.string,
  ctaButton: PropTypes.node,
  className: PropTypes.string,
};

export default EmptyState;
